import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { NoSSR } from '@/components';
import { ChevronRightIcon } from '@/icons';
import { InquiryFormEmbed } from '@/module/embed';
import { PlanExplanation } from '@/module/payment';
import { useCountryCode } from '@/shared/hooks';
import { Button } from '@/ui_v3';
export const Pricing = () => {
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="Pricing" data-sentry-source-file="Pricing.tsx">
      <PricingCards data-sentry-element="PricingCards" data-sentry-source-file="Pricing.tsx" />
      <Inquiry data-sentry-element="Inquiry" data-sentry-source-file="Pricing.tsx" />
    </NoSSR>;
};
const PricingCards = () => {
  const {
    t
  } = useTranslation(['landing', 'common']);
  return <section data-sentry-component="PricingCards" data-sentry-source-file="Pricing.tsx">
      <div className="flex flex-col items-center gap-2xl bg-gradient-to-b from-[#F3F5F9] to-[#F8F9FC] px-md py-xl mobile-lg:px-lg min-[751px]:py-3xl tablet-lg:px-2xl">
        <PlanExplanation data-sentry-element="PlanExplanation" data-sentry-source-file="Pricing.tsx" />
        <Button variant="contained" intent="alternative" size="lg" rounded="default" asChild data-sentry-element="Button" data-sentry-source-file="Pricing.tsx">
          <Link href="/pricing" data-sentry-element="Link" data-sentry-source-file="Pricing.tsx">
            {t('landing.pricingBtn')}
            <ChevronRightIcon size="md" data-sentry-element="ChevronRightIcon" data-sentry-source-file="Pricing.tsx" />
          </Link>
        </Button>
      </div>
    </section>;
};
const Inquiry = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isKR
  } = useCountryCode();
  if (!isKR) return null;
  return <section className="flex flex-col items-center gap-xs bg-neutral px-md pt-[24px]" data-sentry-component="Inquiry" data-sentry-source-file="Pricing.tsx">
      <div className="flex flex-col items-center gap-md">
        <h2 className="text-center text-heading-xl-extrabold text-default">
          {t('common:inquiry.title')}
        </h2>
        <p className="text-center text-body-lg-medium text-neutral">
          {t('common:inquiry.description')}
        </p>
      </div>

      <NoSSR data-sentry-element="NoSSR" data-sentry-source-file="Pricing.tsx">
        <InquiryFormEmbed webFormUrl={t('common:pricing.pricing.contactLink')} title={t('common:inquiry.title')} className="w-full max-w-[568px]" data-sentry-element="InquiryFormEmbed" data-sentry-source-file="Pricing.tsx" />
      </NoSSR>
    </section>;
};